import React from 'react';
import StatusChip from '../../ui/StatusChip/StatusChip';
import { StatusType, StatusVisualStyle, StatusDensity } from '../../ui/StatusChip/StatusChip.types';
import { ChipColor } from './Table.hooks';

const mapChipColorToStatus = (color: ChipColor): StatusType => {
  if (color === 'success') return 'success';
  if (color === 'warning') return 'warning';
  if (color === 'error') return 'error';
  if (color === 'info') return 'info';
  // Map tonos primario/secundario a info para mantener contraste azul/violeta
  if (color === 'primary' || color === 'secondary') return 'info';
  return 'default';
};

interface TableStatusChipProps {
  label: string;
  color?: ChipColor;
  status?: StatusType;
  size?: 'small' | 'medium';
  visualStyle?: StatusVisualStyle;
  withIcon?: boolean;
  density?: StatusDensity;
  className?: string;
}

/**
 * Wrapper compacto para tablas que delega al StatusChip global.
 * Mantiene densidad y permite unificar estilo en un solo punto.
 */
export const TableStatusChip: React.FC<TableStatusChipProps> = ({
  label,
  color = 'default',
  status,
  size = 'small',
  visualStyle = 'quiet',
  withIcon = false,
  density = 'compact',
  className,
}) => {
  const resolvedStatus = status ?? mapChipColorToStatus(color);

  return (
    <StatusChip
      label={label}
      status={resolvedStatus}
      size={size}
      density={density}
      visualStyle={visualStyle}
      withIcon={withIcon}
      className={className}
    />
  );
};
